/** @jsx jsx */

import { Component } from "react";
import { css, jsx } from "@emotion/react";

import google from "../../images/google-logo.svg";
import fb from "../../images/fb-logo.svg";
import trustpilot from "../../images/trustpilot.png";
import bgLeft from "../../images/review-bg-left.svg";
import bgRight from "../../images/review-bg-right.svg";
import ReviewCard from "./ReviewCard";

const reviewData = [
    { name: 'Google', logo: google, rating: '5.0', ratingDesc: '94 Reviews', color: '#393972', link: 'https://www.google.co.nz/search?source=hp&ei=Gxi8X4GnBbOS4-EP8ryx4AQ&q=noissue&oq=noissue&gs_lcp=CgZwc3ktYWIQAzIFCAAQyQMyAggAMgIIADICCAAyAggAMgIIADICCAAyAggAMgIIADICCAA6CwgAELEDEIMBEMkDOgsILhCxAxDHARCjAjoFCAAQsQM6CAguELEDEIMBOg4ILhCxAxCDARDHARCjAjoFCC4QsQM6CAgAELEDEIMBOhEILhCxAxDHARCjAhDJAxCTAjoLCC4QsQMQxwEQrwE6DgguELEDEIMBEMcBEK8BOggIABCxAxDJAzoECC4QClC-DVj2E2CoFWgBcAB4AIABvAGIAb8JkgEDMC43mAEAoAEBqgEHZ3dzLXdperABAA&sclient=psy-ab&ved=2ahUKEwjBoM22vZntAhUzyTgGHXJeDEwQ4dUDegQIABAE&uact=5#lrd=0x6d0d47faf703e105:0x418cdb44d727ce82,1,,,' },
    { name: 'Facebook', logo: fb, rating: '4.7', ratingDesc: '4.7 out of 5 / Based on 162 people', color: '#3B5998', link: 'https://www.facebook.com/pg/noissueco/reviews' },
    { name: 'Trustpilot', logo: trustpilot, rating: '4.6', ratingDesc: '4.6 out of 5 / Based on 184 Reviews', color: '#51B37F', link: 'https://www.trustpilot.com/review/www.noissue.co' },
];

export default class ReviewSection extends Component {
    render() {
        return (
            <section
                css={css`
                    margin: 0 auto;
                    padding: 4rem 0;
                    background-color: #FFD6DE;
                    background-image: url(${bgLeft}), url(${bgRight});
                    background-position: top left, top right;
                    background-repeat: no-repeat;
                `}
            >
            <h1 css={css`
                    padding: 2rem;
                    font-size: 6rem;
                    color: #FD566F;
                    line-height: 6rem;

                    @media(max-width: 768px){
                        font-size: 4rem;
                        line-height: 4rem;
                    }
                `}>Reviews</h1>
                <div css={css`
                    overflow: auto;
                    @media (min-width: 1024px) {
                        ::-webkit-scrollbar {
                            width: 0.5rem;
                            height: 1rem;
                            background-color: transparent;
                            border-radius: 0.5rem;
                        }
                        ::-webkit-scrollbar-thumb {
                            box-shadow: inset 0 0 6px #ededed;
                            border-radius: 10px;
                            background-color: #ededed;
                        }
                    }
            
                `}>
                    <div
                        css={css`
                            text-align: center;
                            margin-top: 7rem;
                            display: flex;
                            flex-wrap: nowrap;
                            margin-bottom: 5rem;
                            min-width: 120rem;
                            max-width: 120rem;
                            justify-content: space-evenly;
                            margin: auto;
                            padding: 2rem 0;
                        `}
                    >
                        {reviewData.map( ( item, index ) =>
                        <ReviewCard key={index} props={item}/>)}

                    </div>
                </div>
            </section>
        );
    }
}
